import React from 'react'
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";
import dynamic from 'next/dynamic';
import Loading from '@/components/common/Loading';
import ThemePark from '@/components/outlet/ThemePark';


const amusementParkManagementSoftware = () => {
  return (
    <>
      <Head>
        <title>Amusement Park Ticketing & Billing Software | QueueBuster POS</title>
        <link rel="canonical" href="https://queuebuster.co/outlet/amusement-park-management-software" />
        <link rel="alternate" href="https://queuebuster.co/outlet/amusement-park-management-software" hrefLang="en" />
        <meta name="description" content="Boost revenue with the best Amusement Park Management Software. Fast ticketing, ride billing, POS, visitor tracking & cashless payments — all in one platform"/>
        <meta property="og:title" content="Best Amusement Park Management & Ticketing POS Software | QueueBuster" />
        <meta property="og:description" content="Manage your amusement park operations smarter with QueueBuster POS. From ticketing and ride billing to cashless payments, visitor tracking, inventory, and reports — our theme park software helps you speed up queues, improve guest experience, and grow profits effortlessly." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Image+Amusement+park.png" />
        <meta property="og:url" content="https://queuebuster.co/outlet/amusement-park-management-software" />
      </Head>
         <SchemaTags page="amusement-park-management-software" />
      <ThemePark />
    </>
  )
}

export default amusementParkManagementSoftware